import helper from './helper.js';
import { AOS, simpleParallax } from '../vendors.js';

var app = {
    init: function () {

        helper.openLogged('.logged-box .bars, .logged-box img, .logged-box p, .bars span, .logged-box', '.logged-menu, header', 'open');
        helper.openLoginPanel('.login-trigger', '.login-panel, header', 'open');
        helper.openSignupPanel('.signup-trigger', '.signup-panel, header', 'open','','html');
        helper.openDownloadPanel('.download-panel-trigger', '.download-panel, header', 'open','','body');
        helper.openSignupDownload('.signup-download-trigger', '.signup-download-panel, header', 'open');
        helper.openContact('.contact-panel-trigger', '.contact-side-panel, header', 'open');
        helper.openPanelMessage('.panel-message-trigger', '.panel-message, header', 'open');
        helper.openTFAPanel('.tfa-trigger', '.tfa-panel, header', 'open');
        helper.headerScroll('header', 'scroll', 40);
        app.sparralax();
        app.slider();
        app.video();
        app.labelAnim();
        app.passwordVisibility();
        app.uploadImage();
        //app.menageSocials();
        app.cancelPopup();
        app.closePanel();
        app.mobileMenu();
        app.loginSignupLinks();
        app.audioPlayer();
        app.tint();
        app.bodyLoad();
        app.parralax()
        app.manuallyRemoveBodyClass()
        //app.toClipboard()
    },
    /*toClipboard: function() {
        $('.copy-to-clipboard').on('click',function() {
            let data = $(this).attr('data-data');
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val(data).select();
            document.execCommand("copy");
            $temp.remove();
            $("body").append("<p class='copy-message'>Copied</p>");
            setTimeout(function () {
                $('.copy-message').fadeOut();
            }, 1500)
        })
    },*/
    manuallyRemoveBodyClass: function() {
        $('header .side-panel .bars').on('click',function() {
            $('body, .logged-menu, html').removeClass('open')
        })
        $(document).on('click','.download-panel .login-trigger, .download-panel .signup-trigger',function() {
            $('.download-panel').removeClass('open')
        })
    },

    passwordVisibility: function () {
        $('.show-password').on('change', function () {
            var target = $('#' + $(this).data('target'));
            target.attr('type', this.checked ? 'text' : 'password');
        });
    },

    mobileMenu: function () {
        $('.menu-box, .menu-trigger').on('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            $('header').toggleClass('opened');
        });

        $('header .overlay').on('click', function () {
            $('header').removeClass('opened');
        });
    },

    parralax: function () {
        var image = document.getElementsByClassName('spparralax');
        new simpleParallax(image, {
            scale: 1.3
        });
    },

    bodyLoad: function () {
        setTimeout(function () {
            $('body').removeClass('loaded');
        }, 450);
    },

    tint: function () {

        var win = $(window);

        if (win.scrollTop() >= 50) {
            $('.hero-anim').addClass("tint");
        } else {
            $('.hero-anim').removeClass("tint");
        }
        win.on('scroll', function () {
            if (win.scrollTop() > 50) {
                $('.hero-anim').addClass("tint");
            } else {
                $('.hero-anim').removeClass("tint");
            }
        });
    },
    audioPlayer: function () {
        if ($('.audio-player-container').length > 0) {
            var $audioPlayer = $(".audio-player").luna(
                {
                    songs: ["Ikson-Paradise.mp3"],
                    onStatusChange: function (e) {
                    }
                }
            );
        }
    },

    loginSignupLinks: function () {
        $('.login-link').on('click', function () {
            $('.side-panel').removeClass('open')
            $('.login-panel').addClass('open')
        });
        $('.signup-link').on('click', function () {
            $('.login-panel').removeClass('open')
            $('.forgot-panel').removeClass('open')
            $('.signup-panel').addClass('open')
        });
        $('.forgot-pass-triger').on('click', function () {
            $('.login-panel').removeClass('open')
            $('.forgot-panel').addClass('open')
        })
        $('.back-login').on('click', function () {
            $('.login-panel').addClass('open')
            $('.forgot-panel').removeClass('open')
        })
        /// contact slide panel
        $('.contact-side-panel .bars').on('click', function () {
            $('.contact-panel').removeClass('open')
        })
    },

    closePanel: function () {
        $('.side-panel .bars').on('click', function () {
            $('.side-panel').removeClass('open')
            $('header').removeClass('open')
        })
    },

    cancelPopup: function () {
        // Show specific popup
        $('.cancel-btn').on('click', function () {
            let uuid = $(this).attr('data-suuid');
            $('#' + uuid).addClass('show');
        })
        // Hide all open
        $('.hide-popup').on('click', function () {
            $('.popup-box').removeClass('show');
            return false;
        })
    },

    /*menageSocials: function () {
        $('.social-delete i').on('click', function () {
            $(this).parent().parent().parent().hide()
        })
        $('.social-copy').on('click', function () {
            $(".social-box:hidden").first().fadeIn();
        });
    },*/

    uploadImage: function () {
        /*function readURL(input) {
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    $('#imagePreview').css('background-image', 'url(' + e.target.result + ')');
                    $('#imagePreview').hide();
                }
                reader.readAsDataURL(input.files[0]);
            }
        }
        $("#imageUpload").change(function () {
            readURL(this);
        });*/

        $('.removeImage').on('click', function () {
            $('#imagePreview').css('background-image', 'url("")');
            $('#imgUploadedName').val('delete');
        })
    },

    labelAnim: function () {
        $('.default-form').find('input, select, textarea').on('input', function (e) {
            $(e.currentTarget).attr('data-empty', !e.currentTarget.value);
        });
    },

    video: function () {
        var trigger = $('.video-module .video-container');
        trigger.on('click', function () {
            if ($(this).attr('data-type').includes("youtube")) {
                var yt = $(this).find('iframe');
                $(this).find('iframe').css('z-index', '6');
                $(this).find('.iframe-container').show()
                yt.attr('src', $(this).attr('data-video'));
            } else {
                var elem = $(this).find('video');
                $(this).find('video').css('z-index', '6').attr('controls', 'true');
                $('.iframe-container').hide()
                var url = $(this).attr('data-video');
                elem.attr('src', url)
                elem.get(0).play()
            }
        })
    },

    slider: function () {
        $('.creators-slider .slider').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: true,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        centerMode: false,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        });
    },

    sparralax: function () {
        // find all layers with class=parallax
        var layers = $(document).find(".anim-slow");

        // SHIFTING FUNCTION
        function Parallax() {
            // Distance to top (and distance+half screen height)
            var top = document.documentElement.scrollTop || document.body.scrollTop,
                topmid = top + window.innerHeight / 2;

            // for every parallax layer
            for (var i = 0; i < layers.length; i++) {
                // define the layer
                var ActiveLayer = layers[i];
                // define parent
                var ActiveParent = $(ActiveLayer).parent();
                // distance from parent to top
                var Distance = ActiveParent.offset().top;
                // Height of parent and parallax layer
                var HeightParent = ActiveParent.height();
                var HeightLayer = $(ActiveLayer).height();
                var Scroll;
                // centered things will use centered top (and subsctract the own height)
                if ($(ActiveLayer).hasClass("faster")) {
                    Scroll = Math.round((topmid - Distance - (HeightLayer / 3)) / -1);
                } else {
                    Scroll = Math.round((top - Distance) / -3);
                }
                $(ActiveLayer).css({
                    transform: "translateY(" + Scroll + "px)",
                    "-moz-transform": "translateY(" + Scroll + "px)",
                    "-ms-transform": "translateY(" + Scroll + "px)",
                })
            }
        }
        Parallax();
        $(window).scroll(function () {
            Parallax();
        })
    },

};

$(document).ready(app.init);

$(window).on("resize", function () {
    AOS.refresh();
});
$(document).ready(function () {
    AOS.init({
        "once": true,
        // jQuery's ready callback can run after load for a cached module entry.
        // AOS handles an already-ready document through its DOMContentLoaded path.
        startEvent: document.readyState === 'complete' ? 'DOMContentLoaded' : 'load',
        duration: 500,
        delay: 300,
    })
});

$(window).on('load', function () {
    //window.addEventListener('load', AOS.refresh);
    if (document.readyState == "complete") {
        AOS.refresh();
    }
    setTimeout(function () {
        $('body').removeClass("no-scroll-y");
    }, 3000);
});
